import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTiersPrioritySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={61} height={54} fill="none" {...props}>
      <path
        stroke="url(#TiersPrioritySmall_svg__a)"
        strokeWidth={5}
        d="M32.19 8.078a5.39 5.39 0 0 1 7.62 0l.592.592a10.4 10.4 0 0 0 7.346 3.043h.15a5.39 5.39 0 0 1 5.39 5.389v.15c0 2.755 1.094 5.397 3.042 7.346l.592.591a5.39 5.39 0 0 1 0 7.621l-.592.592a10.4 10.4 0 0 0-3.043 7.346v.15a5.39 5.39 0 0 1-5.389 5.39h-.15a10.4 10.4 0 0 0-7.346 3.042l-.592.592a5.39 5.39 0 0 1-7.62 0l-.592-.592a10.4 10.4 0 0 0-7.346-3.043h-.15a5.39 5.39 0 0 1-5.39-5.389v-.15c0-2.755-1.094-5.397-3.042-7.346l-.592-.592a5.39 5.39 0 0 1 0-7.62l.592-.592a10.4 10.4 0 0 0 3.043-7.346v-.15a5.39 5.39 0 0 1 5.389-5.39h.15a10.4 10.4 0 0 0 7.346-3.042z"
      />
      <path
        fill="#F7D685"
        d="m28 36 5.986-15h3.984L44 36h-4.336l-1.012-3.126H33.26L32.248 36zm6.162-6h3.61l-1.783-5.538h-.044z"
      />
      <path
        fill="#D3A136"
        d="M.38 3.538 6.647.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L.13 4.597a.733.733 0 0 1 .25-1.06Z"
      />
      <defs>
        <linearGradient
          id="TiersPrioritySmall_svg__a"
          x1={36}
          x2={36}
          y1={4}
          y2={54}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C649" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTiersPrioritySmall);
export default ForwardRef;
